var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-wrapper",
    {
      staticClass: "layout-primary",
      class: { "layout-primary--with-pagination": _vm.$slots.pagination },
      attrs: { "is-scroll-disabled": _vm.isScrollDisabled }
    },
    [
      _c("page-header", {
        attrs: { slot: "pageHeader" },
        on: { closeNav: _vm.enableScroll },
        slot: "pageHeader"
      }),
      _c(
        "main",
        { attrs: { slot: "pageContent" }, slot: "pageContent" },
        [
          _c("modals-container"),
          _c("global-toasts"),
          _vm.showInnerHeader
            ? _c(
                "div",
                {
                  staticClass: "inner-header",
                  class: { noInnerPadding: _vm.titleText === "" }
                },
                [
                  _c(
                    "div",
                    {
                      ref: "fixedHeaderId",
                      staticClass: "inner-header__row fixed-page-header",
                      class: { "is-active": _vm.fixedHeader.fixedActive }
                    },
                    [
                      _c("mobile-nav-toggle", {
                        on: { open: _vm.disableScroll }
                      }),
                      _c("h1", { staticClass: "inner-header__title" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.titleText) +
                            "\n                "
                        )
                      ]),
                      _vm.$slots.titleAction
                        ? _c(
                            "mq-layout",
                            {
                              staticClass: "inner-header__title-action",
                              attrs: { mq: "tablet+" }
                            },
                            [_vm._t("titleAction")],
                            2
                          )
                        : _vm._e(),
                      _vm.$slots.headerRight
                        ? _c(
                            "div",
                            { staticClass: "inner-header__search" },
                            [_vm._t("headerRight")],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "inner-header__row" },
                    [
                      _c("mobile-nav-toggle", {
                        on: { open: _vm.disableScroll }
                      }),
                      _c("h1", { staticClass: "inner-header__title" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.titleText) +
                            "\n                "
                        )
                      ]),
                      _vm.$slots.titleAction
                        ? _c(
                            "mq-layout",
                            {
                              staticClass: "inner-header__title-action",
                              attrs: { mq: "tablet+" }
                            },
                            [_vm._t("titleAction")],
                            2
                          )
                        : _vm._e(),
                      _vm.$slots.headerRight
                        ? _c(
                            "div",
                            { staticClass: "inner-header__search" },
                            [_vm._t("headerRight")],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.$slots.headerContent
                    ? _c(
                        "div",
                        { staticClass: "inner-header__row" },
                        [_vm._t("headerContent")],
                        2
                      )
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _c("spinner", {
            attrs: {
              active: _vm.isActive && !_vm.disableSpinner,
              "full-screen": ""
            }
          }),
          _vm.$slots.notification
            ? _c("div", [_vm._t("notification")], 2)
            : _vm._e(),
          _c(
            "div",
            { staticClass: "layout-primary__content" },
            [
              _c(
                "div",
                { staticClass: "layout-primary__main-content" },
                [
                  _vm.$slots.preContent
                    ? _c(
                        "div",
                        { staticClass: "layout-primary__filter" },
                        [_vm._t("preContent")],
                        2
                      )
                    : _vm._e(),
                  _vm._t("default"),
                  _vm.$slots.pagination
                    ? _c(
                        "div",
                        { staticClass: "layout-primary__pagination" },
                        [_vm._t("pagination")],
                        2
                      )
                    : _vm._e()
                ],
                2
              ),
              _vm.$slots.sideContent
                ? _c(
                    "mq-layout",
                    {
                      staticClass: "layout-primary__side-content",
                      attrs: { mq: "nav+" }
                    },
                    [_vm._t("sideContent")],
                    2
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "base-icon-button",
            {
              ref: "backToTop",
              staticClass: "fixed-page-header__back-to-top",
              class: { "is-active": _vm.fixedHeader.fixedActive },
              attrs: {
                primary: "",
                size: "lg",
                "with-shadow": "",
                "title-text": "$t('general.back')"
              },
              on: {
                click: function() {
                  return _vm.fixedHeader.scrollToTop()
                }
              }
            },
            [_c("svg", [_c("use", { attrs: { "xlink:href": "#chevron-up" } })])]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }